import { useState } from 'react';
import { getContactEmailDisplay } from '@car-pool/shared/contactIdentity';
import { apiFetch } from '../config/api';

export default function ResetCodeButton({ token, userType, userId, userName, contact = null }) {
  const [code, setCode] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleGenerate = async () => {
    setLoading(true);
    setError('');
    setCode(null);
    try {
      const res = await apiFetch('/password-resets/generate', {
        method: 'POST',
        body: JSON.stringify({ user_type: userType, user_id: userId }),
      }, token);
      setCode(res.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSend = async () => {
    setSending(true);
    setSent(false);
    setError('');
    try {
      await apiFetch('/password-resets/send', {
        method: 'POST',
        body: JSON.stringify({ user_type: userType, user_id: userId }),
      }, token);
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSending(false);
    }
  };

  // Generating a code still works for a contact with no real email — an
  // administrator can read it out. Only emailing it is impossible.
  const canSendByEmail = !contact || !getContactEmailDisplay(contact).needsEmail;

  const sendButton = canSendByEmail ? (
    <button
      className="sa-btn sa-btn-secondary"
      style={{ padding: '4px 10px', fontSize: 12 }}
      onClick={handleSend}
      disabled={sending || sent}
    >
      {sending ? 'Sending...' : sent ? 'Reset Link Sent' : 'Send Reset Link'}
    </button>
  ) : null;

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
      {!code ? (
        <>
          <button
            className="sa-btn sa-btn-secondary"
            style={{ padding: '4px 10px', fontSize: 12 }}
            onClick={handleGenerate}
            disabled={loading}
          >
            {loading ? 'Generating...' : 'Reset Code'}
          </button>
          {sendButton}
        </>
      ) : (
        <div style={{
          background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 6,
          padding: '8px 12px', fontSize: 13, display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap',
        }}>
          <span>
            Code for <strong>{userName}</strong>:{' '}
            <code style={{
              background: '#1a2744', color: '#fff', padding: '3px 8px',
              borderRadius: 4, fontSize: 15, fontWeight: 700, letterSpacing: 2,
            }}>
              {code.code}
            </code>
          </span>
          <span style={{ color: '#666', fontSize: 11 }}>
            Expires: {new Date(code.expires_at).toLocaleString()}
          </span>
          {code.reset_url && (
            <a
              href={code.reset_url}
              target="_blank"
              rel="noreferrer"
              style={{ color: '#0369a1', fontSize: 12, textDecoration: 'underline' }}
            >
              Open reset link
            </a>
          )}
          {sendButton}
          <button
            onClick={() => setCode(null)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, color: '#888', padding: 0 }}
            title="Dismiss"
          >
            x
          </button>
        </div>
      )}
      {error && <span style={{ color: '#991b1b', fontSize: 12, marginLeft: 8 }}>{error}</span>}
    </div>
  );
}
